module.exports = __webpack_public_path__ + "img/install.6f961abb.png";